import { Container, Image, Navbar } from 'react-bootstrap';
import NavbarCollapse from 'react-bootstrap/NavbarCollapse'

import background from "../imgs/bg-topo-principal.png";
import gpr from "../imgs/gpr.jpeg";
import gprf from "../imgs/gprf.jpeg";
import logo from "../imgs/logo.png";
// import logoEleicoes from "../imgs/logoeleicoes.jpeg";

function NavBar({ title, subtitle, subsubtitle, modulo }) {
  return (
    <Navbar bg="light" fixed="top" expand="lg" style={{ backgroundImage: `url(${background})`, backgroundPosition: '0 0', backgroundRepeat: 'round' }}>
      <Container>
        <Navbar.Brand>
          <Image src={logo} alt="TRE-SC" style={{ width: 70 }} />
          <Navbar.Text style={{ paddingLeft: 15, verticalAlign: 'middle', paddingTop: 0, paddingBottom: 0 }}>
            <div style={{ fontWeight: "bold", color: 'white' }}>
              {title}
            </div>
            {
              subtitle ?
                (<div style={{ color: 'white' }}>
                  {subtitle}
                </div>) : ("")
            }
            {
              subsubtitle ?
                (<div style={{ color: 'white' }}>
                  {subsubtitle}
                </div>) : ("")
            }
          </Navbar.Text>
        </Navbar.Brand>
        <Navbar.Brand>
          <NavbarCollapse>
            {/* <Image src={logoEleicoes} alt="Eleições 2026" style={{ maxHeight: 83, paddingTop: 3 }} /> */}
            {modulo === 'GPR' && <Image src={gpr} style={{ maxHeight: 83, paddingTop: 3, marginLeft: 10 }} />}
            {modulo === 'GPRF' && <Image src={gprf} style={{ maxHeight: 83, paddingTop: 3, marginLeft: 10 }} />}
          </NavbarCollapse>
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
}

export default NavBar;